import { render, staticRenderFns } from "./UpdatePassDialog.vue?vue&type=template&id=77a33e84&scoped=true"
import script from "./UpdatePassDialog.vue?vue&type=script&lang=js"
export * from "./UpdatePassDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdatePassDialog.vue?vue&type=style&index=0&id=77a33e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a33e84",
  null
  
)

export default component.exports